import vsbl from 'vsbl'

export default videoModule => {
  vsbl(videoModule, { threshold: 0.25 })(() => {
    const video = videoModule.querySelector('video')
    const videoSrc = video.getAttribute('video-data')
    if (!video.src.includes('/files/')) {
      video.setAttribute('src', videoSrc)
    }
    videoModule.classList.add('is-visible')
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/video.js